import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SharedModule } from '../../_shared/shared.module';
import { AlertService } from '../../_shared/services/alert.service';
import { UtilService } from '../../_shared/services/util.service';

import { RoomType } from '../shared/room-type.model';
import { RoomTypeModalService } from '../shared/room-type-modal.service';
import { RoomTypeService } from '../shared/room-type.service';

@Component({
  selector: 'app-room-type-detail',
  templateUrl: './room-type-detail.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class RoomTypeDetailComponent implements OnInit {
  constructor(
    private roomTypeService: RoomTypeService,
    private roomTypeModalService: RoomTypeModalService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private utilService: UtilService
  ) {}

  @Input() roomType: RoomType;
  @Input() mode: string;
  @Input() defaultLanguage;
  @Input() additionalLanguages;
  @Input() isModal = false;

  @Output() private savedRoomType = new EventEmitter<RoomType>();
  @Output() private canceledRoomType = new EventEmitter();

  form: FormGroup;
  formSubmited = false;

  createMode = false;
  editMode = false;
  viewMode = false;

  serverErrors = [];
  sendingForm = false;

  private roomTypeCopy;

  ngOnInit() {
    this.setRoomTypeForm();

    if (this.roomType.id) {
      this.setItemOptions(this.roomType, this.mode);

      this.form.patchValue(this.roomType);
    } else {
      this.createMode = true;
    }
  }

  // Referenced from app-translation-options
  onOpenedTranslation(language) {
    this.roomTypeModalService.openRoomTypeTranslation(this.roomType, language);
  }

  // Referenced from app-item-detail-form-actions
  onSavedRoomType() {
    this.formSubmited = true;

    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'description'];

    if (this.editMode && !fields.some((field) => formData[field] !== this.roomTypeCopy[field])) {
      this.onCanceled();
      return;
    }

    this.sendingForm = true;

    this.roomTypeService
      .saveRoomType(this.roomType.id, formData, this.defaultLanguage.lang)
      .subscribe({
        next: (response) => {
          let msg = '';

          if (this.editMode) {
            msg = 'MODIFIED_ROOM_TYPE';

            // needed if we want to keep the page opened or if used in page
            // this.roomType = response;
            // this.setItemOptions(response);
          } else {
            msg = 'NEW_ADDED_ROOM_TYPE';
            // this.roomType = response; // reload item - needed ?
          }

          this.alertService.open(msg);

          // this.setItemOptions(response); // check, specially roomTypeCopy

          this.sendingForm = false;

          this.savedRoomType.emit(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  // Referenced from app-item-detail-form-actions
  onCanceled() {
    // if (this.editMode) {
    //   this.cancelEdit();
    //   return;
    // }

    this.canceledRoomType.emit();
  }

  // Referenced from app-item-detail-form-actions
  onEditedRoomType() {
    this.editMode = true;
    this.viewMode = false;
  }

  // private cancelEdit() {
  //   this.roomType = this.roomTypeCopy;
  //   this.setItemOptions(this.roomType);
  // }

  private setItemOptions(roomType, mode = '') {
    this.createMode = false;
    this.editMode = false;
    this.viewMode = true;

    if (mode === 'edit') {
      this.onEditedRoomType();
    }

    this.roomTypeCopy = { ...roomType };
  }

  private setRoomTypeForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: '',
    });
  }
}

/*

const formData = this.utilService.deleteNullFields(fields, this.form.value);

 this.form = this.formBuilder.group({
      name: [
        this.roomType.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: this.roomType.description,
    });

*/
